<!-- <p>add-prod works!</p> -->
<div class="card">
  <div class="card-body">
    <!-- <div class="mb-4 d-md-flex align-items-center justify-content-between">
      <div>
        <h4>Client Name: {{ ClientName }}</h4>
        <p>Attaching Recipe to Job:  {{ JobName }}</p>
      </div>
    </div> -->
    <div class="row">
      <div class="col-md-12">
        <form [formGroup]="addMaterialForm" class="ng-pristine ng-valid">
          <div class="row">
            <div class="col form-group mb-3">
              <label class="form-label">Client Name</label>
              <select class="form-select" formControlName="clientName" required>
                <option value="" disabled>Select Client</option>
                <option *ngFor="let client of clientList" [value]="client.clientName">{{ client.clientName }}</option>
              </select>
            </div>
            <div class="col form-group mb-3">
              <label class="form-label">Job Name</label>
              <select class="form-select" formControlName="jobName" required>
                <option value="" disabled>Select Job Name</option>
                <option *ngFor="let job of jobList" [value]="job">{{ job }}</option>
              </select>
            </div>
            <div class="col form-group mb-3">
              <label class="form-label">Selected Materials</label>
              <select class="form-select" formControlName="process" [(ngModel)]="selectedProcess" (change)="onProcessSelect($event.target.value)">
                <option value="" disabled>Select Material</option>
                <option *ngFor="let process of selectedMaterials" [value]="process">{{ process }}</option>
              </select>
            
          </div>
          </div>
          <p>Material Mixing for Purchase Order: 0 || Kgs: 500</p>
          <div class="row">
            <div class="col form-group mb-3">
              <label class="form-label">Material</label>
              <select class="form-select" formControlName="material" [(ngModel)]="selectedMaterial" (change)="onMaterialSelect($event.target.value)">
                <option value="" disabled>Select Material</option>
                <option *ngFor="let material of materialOptions" [value]="material">{{ material }}</option>
              </select>
          </div>
          
            <div class="col form-group mb-3">
              <label class="form-label">rollNo</label>
              <input type="number" class="form-control" formControlName="rollNo" placeholder="rollNo" />
            </div>
            <div class="col form-group mb-3">
              <label class="form-label">weight </label>
              <input type="text" class="form-control" formControlName="weight" placeholder="Weight" />
            </div>
            <div class="col form-group mb-3">
              <label class="form-label">return </label>
              <input type="text" class="form-control" formControlName="return" placeholder="return" />
            </div>
            <!-- <div class="col-auto mt-4">
              <button type="submit" class="btn btn-outline-danger" (click)="addMaterial()">Add Material</button>
            </div> -->
          </div>




          <h5 _ngcontent-thg-c101="" class="danger-text">Production Output Records</h5>
          <div class="row">
            <!-- <div class="col form-group mb-3">
              <label class="form-label">Material</label>
              <select class="form-select" formControlName="material" [(ngModel)]="selectedMaterial" (change)="onMaterialSelect($event.target.value)">
                <option value="" disabled>Select Material</option>
                <option *ngFor="let material of materialOptions" [value]="material">{{ material }}</option>
              </select>
          </div> -->
          
            <div class="col form-group mb-3">
              <label class="form-label">Roll No</label>
              <input type="number" class="form-control" formControlName="outputRollNo" placeholder="rollNo" />
            </div>
            <div class="col form-group mb-3">
              <label class="form-label">Output Kgs </label>
              <input type="text" class="form-control" formControlName="outputKgs" placeholder="output kgs" />
            </div>
            <div class="col form-group mb-3">
              <label class="form-label">Waste Kgs</label>
              <input type="text" class="form-control" formControlName="wasteKgs" placeholder="Waste Kgs" />
            </div>
            <div class="col form-group mb-3">
                <label class="form-label">Flag</label>
                <input type="text" class="form-control" formControlName="flag" placeholder="flag" />
              </div>
            <div class="col-auto mt-4">
              <button type="submit" class="btn btn-outline-danger" (click)="addMaterial()">Save Data</button>
            </div>
          </div>



        </form>
      </div>
    </div>
  </div>
</div>

<div class="card mb-4">
  <div class="card-body">

    <div class="row">
      <!-- Grid column -->
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-10">
            <h3 class="text-center font-bold font-up danger-text">
              Client Name: {{ ClientName }} <br> Jobname:  {{ JobName }}
              <!-- Jobname: LXM0025 Boss Baker Chocolate Hazelnut 72565 ----||----Total Mat Req for this Job: 785.4469273743 -->
            </h3>
          </div>
          <!-- <div class="col-md-2">
            <a  class="btn btn-outline-dark btn-sm active" role="button" aria-pressed="true" (click)="saveAndContinue()">Save &
              Continue</a>
          </div> -->
        </div>
      </div>
      <!-- Grid column -->
    </div>
    <!-- Grid row -->
    <div class="table-responsive">
      <table class="table table-bordered red-border text-center">
        <thead>
          <tr>
            <th>P.O No.</th>
            <th>Material</th>
            <th>Input Kgs</th>
            <th>return</th>

            <th>Roll ID</th>
            <th>Ref No.</th>
            <th>Output Kgs</th>
            <th>Output Waste</th>
           
           
            <th>Flag</th>

            <th>Order No</th>
           
            <!-- <th>Mat_Required</th>
            <th>Action</th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let entry of paginatedMaterialMixEntries; let i = index">
            <td>0</td>
            <td>{{ entry.matArray[0].materialMix}}</td>
            <td>{{ entry.matArray[0].weight }}</td>
            <td>{{ entry.matArray[0].return }}</td>

            <td>{{ entry.matArray[0].rollNo }}</td>
            <td>LXM0487</td>
            <!-- <td>{{ entry.matArray[0]?.materialMix?.name }}</td> -->

            <td>{{ entry.matArray[0].outputKgs }}</td>
            <td>{{ entry.matArray[0].wasteKgs }}</td>
         
           
            <td>{{ entry.matArray[0].flag}}</td>
            <td>order</td>
           
            <!-- <td>{{ entry.matArray[0].matRequired }}</td>

            <td>
              <button type="button" routerLink="#" class="btn btn-outline-success btn-sm" (click)="calculateMatRequired(i)">
                <i class="feather icon-dollar-sign "></i> Calc MatReq
              </button>
              <button type="button" class="btn btn-outline-danger btn-sm" (click)="deleteMaterialMix(i)">
                <i class="feather icon-trash-2 text-danger"></i> Delete
              </button>
            </td> -->
          </tr>
          
        </tbody>
      </table>
    </div>
    <div class="pagination-container">
      <div class="pagination mt-3 d-flex justify-content-between align-items-center">
        <div>
          <p>Showing {{ calculateRangeStart() }} - {{ calculateRangeEnd() }} of {{ materialMixEntries.length }}</p>
        </div>
    
        <div class="d-flex">
          <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)" [ngClass]="{'disabled': currentPage === 1}">
            <i class="feather icon-chevrons-left"></i>
          </a>
          <ng-container *ngFor="let page of getNumberRangeMatMix(ceilValue(materialMixEntries.length / itemsPerPage))">
            <a class="pagination-circle" [class.active]="currentPage === page" (click)="onPageChange(page)">
              {{ page }}
            </a>
            <span *ngIf="page < ceil(materialMixEntries.length / itemsPerPage)" class="page-number-space"></span>
          </ng-container>
          <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)" [ngClass]="{'disabled': currentPage === ceilValue(materialMixEntries.length / itemsPerPage)}">

            <i class="feather icon-chevrons-right"></i>
          </a>
        </div>
      </div>
    </div>
    
  </div>
</div>
